exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-recaptcha {\n  display: block;\n  clear: both;\n}", ""]);

// exports
